/**
 * This is the Main layout component which will be common for all pages it contains header and the side nav bar
 */

import React, { FC, HTMLAttributes, useEffect } from "react";
import { Box, CssBaseline } from "@mui/material";
import NavigationDrawer from "../../layouts/side-nav-bar";
import "./style.scss";
import { isSourcePos } from "../../helpers/common-helper";
import { getLocalStorage, removeLocalStorage } from "../../utils";
import { AUTH_TOKEN, STATE } from "../../data/local-storage-constants";
import history from "../../history";
import { LOGIN_PAGE_ROUTE } from "../../data/routes-constants";

interface LayoutProps extends HTMLAttributes<HTMLDivElement> {
  activeTabIndex: number;
}

const MainLayout: FC<LayoutProps> = (props): JSX.Element => {
  let atoken = getLocalStorage(AUTH_TOKEN)
  useEffect(() => {
    if (!atoken) {
      removeLocalStorage(AUTH_TOKEN);
      removeLocalStorage(STATE);
      history.push(LOGIN_PAGE_ROUTE);
      window.location.reload();
    }
  }, [atoken]);
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <NavigationDrawer
        activeTabIndex={props.activeTabIndex}
      >
        {props.children}
      </NavigationDrawer>
      <main className={`rista-body-container overflow-x-hidden relative bg-[#F0F0F0] pt-[85px] ${isSourcePos()?"sm:pt-[74px]":"sm:pt-[130px]"}`}>{props.children}</main>
    </Box>
  );
};

export default MainLayout;